import { FC } from "react"
import icon from "../../../assets/subs-icon.svg"

export const NoSubs: FC = () => {
	return (
		<div className="mx-auto max-w-md px-4 sm:max-w-lg md:max-w-xl lg:max-w-2xl">
			<div className="flex flex-col items-center justify-center gap-4 rounded-xl border-gray-200 bg-white p-6 shadow-sm sm:p-5">
				<img
					src={icon}
					alt="No subscriptions"
					className="sm:h-30 sm:w-30 h-24 w-24 object-contain"
				/>
				<div className="text-center">
					<h2 className="text-lg font-semibold text-gray-800 sm:text-xl">
						No Active Subscriptions
					</h2>
					<p className="font-roboto mt-2 text-[16px] font-normal leading-[24px] text-[#374151]">
						You don’t have any active subscriptions at the moment.
					</p>
				</div>
				<div className="font-roboto mt-2 text-[16px] font-normal leading-[24px] text-[#374151]">
					{"Need help? "}
					<a href="mailto:support@modernfootball.com" className="text-blue-600">
						support@modernfootball.com
					</a>
				</div>
			</div>
		</div>
	)
}
